import { decorationBackgroundSVG, toRem, toRems } from "../../../../helpers/theme";

const style = ({ theme, hasText, largeSpacing }) => {
    const config = {
        text: {
            maxWidth: 200,
            fontSize: 16,
            color: theme?.colors?.drawer?.separator?.text,
        },
        wave: {
            minWidth: 30,
            height: 4,
            spacing: 6,
            color: theme?.colors?.drawer?.separator?.graphic || "#E0E0E0",
        },
    };

    return {
        position: "relative",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "flex-start",
        textAlign: "center",
        margin: toRems([24, 0]),
        ...(hasText && {
            minHeight: toRem(25),
        }),
        ...(largeSpacing && {
            margin: toRems([36, 0]),
        }),
        [theme.breakpoints.up("md")]: {
            margin: toRems([35, 0]),
            ...(largeSpacing && {
                margin: toRems([56, 0]),
            }),
        },
        "& .separator_wave": {
            position: "relative",
            minWidth: toRem(config?.wave?.minWidth),
            display: "inline-flex",
            flex: 1,
            margin: toRems([0, config?.wave?.spacing, 0, 0]),
            width: "100%",
            height: toRem(config?.wave?.height),
            backgroundImage: decorationBackgroundSVG(config?.wave?.color),
            backgroundRepeat: "repeat-x",
            backgroundPosition: "center",
            backgroundSize: "auto 100%",
            ...(hasText && {
                backgroundPosition: "center right",
            }),
        },
        "& .separator_text": {
            display: "inline-flex",
            flex: "0 0 auto",
            maxWidth: toRem(config?.text?.maxWidth),
            fontSize: toRem(config?.text?.fontSize),
            lineHeight: 1.2,
            color: config?.text?.color,
            [theme.breakpoints.up("md")]: {
                lineHeight: 1.4,
            },
            "& + .separator_wave": {
                margin: toRems([0, 0, 0, config?.wave?.spacing]),
                backgroundPosition: "center left",
            },
        },
    };
};

export default style;
